import React__default, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { setTestId } from '../../lib/testId.js';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { Box } from '../layout/Box.js';
import '../layout/BulletList.js';
import '../layout/Column.js';
import '../layout/Columns.js';
import { Hidden } from '../layout/Hidden.js';
import { Inline } from '../layout/Inline.js';
import { Stack } from '../layout/Stack.js';
import '../layout/VisuallyHidden.js';

const AccordionButton = styled.button`
  height: 1.5rem;
  font-family: inherit;
  font-size: inherit;
  border: none;
  border-bottom: 1px solid ${COLOR_PALETTE.slateGrey60};
  background: none;
  margin: 0;
  padding: 0;
  padding-bottom: 0.5rem;
  cursor: pointer;
  text-align: left;
  color: inherit;
  outline: none;
  position: relative;
`;
const AccordionHeading = styled.span`
  vertical-align: top;
  font-size: 1rem;
  font-weight: 600;
  color: ${COLOR_PALETTE.slateGrey100};
`;
const ToggleSVG = ()=>{
    return React__default.createElement("svg", {
        width: "12",
        height: "6",
        viewBox: "0 0 12 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, React__default.createElement("path", {
        d: "M12 0H0L6 6L12 0Z",
        fill: COLOR_PALETTE.slateGrey40
    }));
};
const ToggleIcon = styled.div`
  height: 0.75rem;
  width: 0.75rem;
  transform: rotate(-90deg);
  transition: transform 0.2s ease-out;

  [data-hpy-web-accordion-open] & {
    transform: rotate(0deg);
  }
`;
const ContentBox = styled(Box)`
  height: 0;
  overflow: hidden;

  [data-hpy-web-accordion-closed] & {
    margin-top: 0;
    padding: 0;
  }

  [data-hpy-web-accordion-open] & {
    height: 100%;
    margin-bottom: 1rem;
  }
`;
const Accordion = ({ label , open =true , onToggle , testId ="X" , children , ...props })=>{
    const [collapsed, setCollapsed] = useState(!open);
    const handleToggle = useCallback(()=>{
        if (onToggle !== undefined) {
            onToggle(collapsed);
        }
        setCollapsed(!collapsed);
    }, [
        collapsed,
        onToggle
    ]);
    return React__default.createElement(Stack, {
        "data-hpy-web-accordion": true,
        ...props,
        gap: 1.5,
        ...collapsed ? {
            "data-hpy-web-accordion-closed": true
        } : {
            "data-hpy-web-accordion-open": true
        }
    }, React__default.createElement(AccordionButton, {
        type: "button",
        ...setTestId("Accordion-" + testId),
        onClick: handleToggle
    }, React__default.createElement(Inline, {
        gap: 0.5
    }, React__default.createElement(ToggleIcon, null, React__default.createElement(ToggleSVG, null)), React__default.createElement(AccordionHeading, null, label))), React__default.createElement(ContentBox, {
        padding: [
            0.5,
            0
        ],
        width: "fill"
    }, React__default.createElement(Hidden, {
        visibility: collapsed ? "hidden" : "visible",
        width: "fill"
    }, children)));
};
Accordion.dataId = "data-hpy-web-accordion";
Accordion.displayName = "Accordion";

export { Accordion };
